import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function CustomerOrders(props) {
  const [show, setShow] = useState({})
  //const [isloggedIn, setIsloggedIn] = useState(true);
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')
  let { customerId } = useParams()

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const toggleComment = (id) => {
    setShow((prevShow) => ({ ...prevShow, [id]: !prevShow[id] }))
  }

  const doSubmit = async (customerOrder) => {
    console.log('Tilaus peruttu')
    let orderId = Number(customerOrder.orderId)
    console.log('orderId', orderId)
    let newData = {
      orderId: orderId,
      state: 'disabled',
    }
    try {
      await axios.post(
        `${SERVER_URI}/disable_order/${orderId}`,
        { orderId: orderId },
        { headers: { Authorization: `Token ${userToken}` } }
      )
    } catch (e) {
      console.log('Error in deleting the order', e)
    }
    props.dispatch({
      type: 'UPDATE_ORDER_STATE',
      data: { newOrderState: newData },
    })
  }
  function formatDate(string) {
    var options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }
    return new Date(string).toLocaleString([], options)
  }

  function translateTypeString(string) {
    var options
    if (string === 'immediate') {
      options = 'Hetitilaus'
    } else if (string === 'approximate') {
      options = 'Nointilaus'
    } else if (string === 'timed_reservation') {
      options = 'Aikatilaus'
    }
    return options
  }
  function translateStateString(string) {
    var options
    if (string === 'received') {
      options = 'Vastaanotettu'
    } else if (string === 'accepted') {
      options = 'Hyväksytty'
    } else if (string === 'finalized') {
      options = 'Viimeistelty'
    } else if (string === 'cancelled') {
      options = 'Peruutettu'
    } else if (string === 'underway') {
      options = 'Ajossa'
    } else if (string === 'disabled') {
      options = 'Käytöstä poistettu'
    }
    return options
  }

  return (
    <div className='customerOrders_list'>
      <span>
        <h2>Asiakkaan tilaukset</h2>
        <div className='customerOrders_listing'>
          {props.customerOrderList === undefined ? (
            <LoginRequest />
          ) : (
            props.customerOrderList
              .filter((order) => Number(order.ordererId) === Number(customerId))
              .sort((a, b) => (a.itemM > b.itemM ? 1 : -1))
              .map((customerOrder, index) => (
                <div
                  className={
                    customerOrder.state === 'disabled'
                      ? 'disabledOrder'
                      : 'customer_list'
                  }
                  key={index}
                  id={customerOrder.orderId}
                  onClick={() => toggleComment(customerOrder.orderId)}
                >
                  {customerOrder.pickUpLocation},{' '}
                  {customerOrder.pickUpMunicipality}
                  <br />
                  <div
                    className={show[customerOrder.orderId] ? 'showCar' : 'hide'}
                  >
                    <span>Tilauksen ID: </span>
                    <br className='mobile-break' /> {customerOrder.orderId}{' '}
                    <br />
                    <span>Matkustajien määrä:</span>
                    <br className='mobile-break' />{' '}
                    {customerOrder.passengerCount}
                    <br />
                    <span>Tilaustyyppi:</span>
                    <br className='mobile-break' />{' '}
                    {translateTypeString(customerOrder.orderType)}
                    <br />
                    <span>Nouto-osoite: </span>
                    <br className='mobile-break' />{' '}
                    {customerOrder.pickUpLocation},
                    {customerOrder.pickUpMunicipality}
                    <br />
                    <span>Nouto-aika: </span> <br className='mobile-break' />
                    {formatDate(customerOrder.pickUpTime)}
                    <br />
                    <span>Kohde-osoite: </span>
                    <br className='mobile-break' />
                    {customerOrder.targetLocation},{' '}
                    {customerOrder.targetMunicipality}
                    <br />
                    <span>Nouto-ajan vaihteluväli: </span>
                    <br className='mobile-break' />
                    {customerOrder.timeTolerance} min
                    <br />
                    <span>Tilauksen tila: </span>
                    <br className='mobile-break' />
                    {translateStateString(customerOrder.state)}
                    <br />
                    <button
                      id='gradient_Button'
                      onClick={() => doSubmit(customerOrder)}
                    >
                      Peruuta kyyti
                    </button>
                  </div>
                </div>
              ))
          )}
        </div>
      </span>
    </div>
  )
}

export default CustomerOrders
